// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"cc53291b","764":"d5497286"}[chunkId] + ".chunk.css";
};